import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosAtheneum } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  athProgramsListRoute,
  athProgramUpdateDeleteRoute,
} from '../../utils/apiRoutes';

export const getAllProgramsAsync = createAsyncThunk(
  `${moduleName}/getAllProgramsAsync`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosAtheneum({
        method: 'GET',
        url: athProgramsListRoute(),
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createProgramAsync = createAsyncThunk(
  `${moduleName}/createProgramAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosAtheneum({
        method: 'POST',
        url: athProgramsListRoute(),
        data: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProgramAsync = createAsyncThunk(
  `${moduleName}/updateProgramAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, bodyData } = payload;
      const response = await axiosAtheneum({
        method: 'PATCH',
        url: athProgramUpdateDeleteRoute(id),
        data: { ...bodyData },
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteOneProgramAsync = createAsyncThunk(
  `${moduleName}/deleteOneProgramAsync`,
  async (_id) => {
    const response = await axiosAtheneum({
      method: 'DELETE',
      url: athProgramUpdateDeleteRoute(_id),
    });
    const data = response.data;
    return data;
  }
);

const programSlice = createSlice({
  name: `${moduleName}/Program`,
  initialState: {
    loading: false,
    programs: [],
    oneprogram: [],
    postprogram: null,
  },
  reducers: {},
  extraReducers: {
    [getAllProgramsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getAllProgramsAsync.fulfilled]: (state, action) => {
      console.log('test', action);
      state.loading = false;
      state.programs = action.payload.data;
    },
    [getAllProgramsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [createProgramAsync.pending]: (state) => {
      state.loading = true;
    },
    [createProgramAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.postprogram = action.payload;
    },
    [createProgramAsync.rejected]: (state) => {
      state.loading = false;
    },
    //delete one user
    [deleteOneProgramAsync.pending]: (state) => {
      state.loading = true;
    },
    [deleteOneProgramAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.oneprogram = action.payload;
    },
    [updateProgramAsync.rejected]: (state) => {
      state.loading = false;
    },
    [updateProgramAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [updateProgramAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default programSlice.reducer;
